module.exports = __webpack_public_path__ + "static/media/insightsCover.6769de62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/insightsCover.jpg
// module id = 817
// module chunks = 3